<!-- <app-common-page-breadcrumbs [pageTitle]="title" [navigationData]="navigationData"></app-common-page-breadcrumbs> -->
<div class="container-fluid p-0  scroll">
        
<div id="loader" *ngIf="enableLoader"></div>
<div *ngIf="!enableLoader">

  <div class="mb-0 py-4 border-bottom" style="background: #F8F9FA;">
      <div class="container ">
          <div class="row">
              <div class="col-md-10">
          <!-- uncomment for navigation breadcrumbs -->
              <breadcrumb #parent>
                  <ol class="breadcrumb ml-1 p-0 mb-1">
                  <li class="breadcrumb-item">
                      <a (click)="homeLinkClick(true)"  [routerLink]="['']">BHP Connect</a>
                  </li>
                  <li class="breadcrumb-item">
                      <a (click)="homeLinkClick(true)"  [routerLink]="['']">{{navigationData}}</a>
                  </li>
                  <!-- <ng-template ngFor let-route [ngForOf]="parent.breadcrumbs">
                      <li *ngIf="!route.terminal" class="breadcrumb-item">
                      <a href="" [routerLink]="[route.url]">{{ route.route.data.translation | cxTranslate }}</a>
                      </li>
                      <li *ngIf="route.terminal" class="breadcrumb-item " aria-current="page">{{ route.route.data.translation | cxTranslate }}</li>
                  </ng-template> -->
                  </ol>
              </breadcrumb>
              <h2 class="breadcrumb-page">{{title}}</h2>
              </div>
              <!-- <div class="col-md-2">
                  <h3 class="breadcrumb-page">{{railid}}</h3>
              </div> -->

          </div>
          
      </div>
  </div>

  <div class="mb-0 py-4 border-bottom" style="background: #F8F9FA;">
      <div class="container ">
      <a class="strong  text-primary" (click)="backToRailsList()">< {{  'home.vms.back' | cxTranslate }}</a>
  </div>
  </div>
  <div  *ngIf="!enableLoader">
    <div class="filter-nav overflow-visible">
        <div class="container d-none d-lg-block">
            <div class="d-flex justify-content-between">
              <div class="d-flex">
                <div class="md-semibold-font text-black small p-2 text-nowrap">{{ 'home.productHeader.Filter' | cxTranslate }}</div>
                  <div class="mr-3 picker" >
                    <input name="datepicker" placeholder="{{ 'home.contracts.dateRange' | cxTranslate }}"
                        class="form-control mobile ml-2 mt-3 filter-bar-input" #datepicker1="ngbDatepicker"
                        ngbDatepicker [displayMonths]="2" [dayTemplate]="t" [autoClose]="'outside'"
                        (dateSelect)="onDateSelection($event,datepicker1)"
                        [value]="formatter.format(startDate)?formatter.format(startDate)+' - '+formatter.format(endDate):''"
                        autocomplete="off" outsideDays="collapsed" [startDate]="startDate!" outsideDays="hidden"
                        (click)="toggle(datepicker1)">
                    <ng-template #t let-date let-focused="focused">
                        <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                            [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                            (mouseleave)="hoveredDate = null">
                            {{ date.day }}
                        </span>
                    </ng-template>
                    <ng-template #footerTemplate>
                        <hr class="my-0">
                        <button class="btn btn-primary btn-sm m-2 float-left" (click)="resetCalendar(datepicker)">{{
                            'home.contracts.Reset' | cxTranslate }}</button>
                        <button class="btn btn-secondary btn-sm m-2 float-right" (click)="datepicker.close()">{{
                            'home.quote.Close'
                            | cxTranslate }}</button>
                    </ng-template>
                </div>

                  <div class="mr-2">
                    <!-- <ng-select [items]="StatusList" [multiple]="true" [clearable]="false" bindLabel="name" dropdownPosition="bottom"
                      groupBy="StatusList" [selectableGroup]="false" [closeOnSelect]="true" placeholder="{{'shipment.SelectStatus' | cxTranslate}}" bindValue="code"
                      [(ngModel)]="selectedStatus" notFoundText="No Items Found" (change)="changeStatus()">
                      <ng-template ng-multi-label-tmp>
                        <span class="filter-count pl-2 text-black">{{selectedStatus?.length}}x {{'shipment.statusselected' | cxTranslate}}</span>
                      </ng-template>
                      <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                        <input type="checkbox" /><span class="ff-semibold "> {{'shipment.status' | cxTranslate}}</span>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                          <input *ngIf="item.name!==undefined && item.name!==''" id="{{item.code}}" type="checkbox"
                            [ngModel]="item$.selected" [checked]="item.selected" /> <span>{{item.name}}</span>
                      </ng-template>
                    </ng-select> -->
                     <ng-select [items]="StatusList" [multiple]="true" [clearable]="false" bindLabel="name"
                            dropdownPosition="bottom" groupBy="StatusList" [selectableGroup]="false"
                            [closeOnSelect]="true" placeholder="{{'shipment.SelectStatus' | cxTranslate}}"
                            bindValue="code" [(ngModel)]="selectedStatus" notFoundText="No Items Found"
                            (change)="changeStatus()">
                            <ng-template ng-multi-label-tmp>
                                <span class="filter-count pl-2 text-black">{{selectedStatus?.length}}x
                                    {{'shipment.statusselected' | cxTranslate}}</span>
                            </ng-template>
                            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                                <input type="checkbox" /><span class="ff-semibold "> {{'shipment.status' |
                                    cxTranslate}}</span>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                <input *ngIf="item.name!==undefined && item.name!==''" id="{{item.code}}"
                                    type="checkbox" [ngModel]="item$.selected" [checked]="item.selected" />
                                <span>{{item.name}}</span>
                            </ng-template>
                        </ng-select>

                    </div> 
                <div *ngIf="showClear">
                  <button type="button" class="btn btn-warning clear-text " (click)="clearAllFilter()">
                    {{'home.productHeader.ClearFilter' | cxTranslate }}</button>
                </div> 
              </div>
              <div class="ml-auto d-flex">
                <div class="mr-4 d-none d-lg-block">           
                <div class="d-flex">
                    <!-- <a (click)="donwloadReport('screening_report')" class="mr-2 mt-2" >{{'shipment.Export' | cxTranslate}}</a> -->
                    <button (click)="downloadShipmentReport('SHIPS_AND_DOCS_RAIL_DETAIL_REPORT')" type="button" class="float-right btnheight d-none d-sm-block btn btn-secondary" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false"><img src="/images/download_report.svg" alt="customlogo" width="25px" height="25px"> &nbsp;
                    Download Report
                    </button>
                </div>
            
                </div>
                <!--search function desktop-->
                <div class="d-flex align-items-center mr-2 search-section-col">
                <div class="search-section-div">
                    <div class="input-group d-flex align-items-center">
                    <input class="form-control form-control-lg border rounded-pill input-field" type="search"
                        (keypress)="omitSpecialChar($event)" [(ngModel)]="searchText" (input)="search()" style=" margin-bottom: auto" 
                        placeholder="{{ 'home.productHeader.Search' | cxTranslate }}">
                    <span class="input-group-append">
                        <button name='searchbuttondesktop'
                        class="btn btnUpgrade rounded-pill border-0 input-field bg-white border-start-0 border-bottom-0 border ms-n5"
                        type="button">
                        <i class="fa fa-search pe-none"></i>
                        </button>
                    </span>
                    </div>
                </div>
                </div>       
                </div>
            </div>
          </div>
          <div class="container d-lg-none">
            <div class="row">
              <div class="w-100">
                <div class="filter-select-div-mobile pl-4">
                  <div class="input-group">
                    <input class="form-control border rounded-pill input-field mr-5" type="search" (input)="search()"
                      (keypress)="omitSpecialChar($event)" [(ngModel)]="searchText" placeholder="{{'shipment.search' | cxTranslate}}">
                    <span class="input-group-append">
                      <button name='searchbuttonfilter' class="
                              btn
                              btnUpgrade
                              border-0
                              input-field
                              border-start-0 border-bottom-0 border
                              ms-n5
                            " type="button">
                      <i class="fa fa-search mobbar"></i>
                    </button>
                    </span>
                    <div class="ml-1 dropdown show">
                      <button type="button" *ngIf="this.display=='delivery'" (click)="donwloadReport('batches_report')" style="min-height: auto;"
                        class="float-right btn btn-sm btn-secondary" href="#" role="button"
                        id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img
                          src="/images/download_report.svg" alt="customlogo" width="25px" height="25px">
                        </button>
                      
                      <!-- <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
                          <a  style="min-height: fit-content;" class="dropdown-item"  >{{'shipment.batchesreport' | cxTranslate}}</a>
                          <a style="min-height: fit-content;" class="dropdown-item" >{{'shipment.screeningreport' | cxTranslate}}</a>
                    </div> -->
                    </div>
                    <div class='hidden-xs-filter-bar pr-1 ml-1' (click)='filtersidebar()'>
                      <img class="ml-1" src="/images/filternew.svg"><sup class="pl-2 pr-2 pt-1 pb-1"
                        *ngIf='length'>{{length}}</sup>
                      <div class="ff-semibold fs-10 d-flex align-items-center text-black Filternew">{{ 'home.filter.filters' |
                        cxTranslate }}</div>
                    </div>
                
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <div [ngClass]="sidebar ?'hide-mobile-filter-sidebar': 'mobile-filter-sidebar' "
              class="hidden-xs-filter-bar sidebar">
              <div class='sticky-top  d-flex justify-content-between p-3 border sticky'>
                <div class="fs-24 md-semibold-font pl-1">{{ 'home.productHeader.Filter' | cxTranslate }}:</div>
                <div (click)="closebar()"><img src="/images/sidebarcross.svg" alt=""> </div>
              </div>
              <div class="scrollbar">
                <div>
                  <div class="d-flex md-semibold-font small pl-3 pt-3 pb-2">{{'shipment.ports' | cxTranslate}} :</div>
                  <div *ngFor="let ports of portData; let i=index" class="ml-5 small d-flex line-height">
                    <label class="ff-normal" *ngIf="ports.name!==undefined && ports.name!==''">
                      <input type="checkbox" [(ngModel)]="ports.selected" [value]="ports.id"
                        [checked]="ports.selected" (change)="portsmobileFilter($event, ports.id)" />
                      {{ports.name}}
                    </label>
                  </div>
                </div>
                <div>
                  <div class="d-flex md-semibold-font small pl-3 pt-3 pb-2">{{'shipment.status' | cxTranslate}} :</div>
                  <div *ngFor="let status of StatusList; let i=index" class="ml-5 small d-flex line-height">
                    <label class="ff-normal" *ngIf="status.name!==undefined && status.name!==''">
                      <input type="checkbox" [(ngModel)]="status.selected" [value]="status.code"
                        [checked]="status.selected" (change)="statusmobileFilter($event, status.code)" />
                      {{status.name}}
                    </label>
                  </div>
                </div>
              </div>
              <div class="sticky-bottom p-4 border-top">
                <button class="btn btn-block btn-primary w-100" (click)="getResults()">{{ 'home.contracts.seeResults'|cxTranslate}}</button>
                <button class='btn btn-block' (click)="clearFilterDataMobile($event);closebar()">{{ 'home.contracts.clearFilter' |
                  cxTranslate}}</button>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="container" >
        <div class="table-container mt-4" >
                <form [formGroup]="form">
                <table class="table table-wrapper static-table ">
                    <thead class="stickyHeaders">
                    <tr>
                        <th *ngFor="let headername of tableheaders;let z=index " scope="col"
                        class="smal static-th text-left text-black arrow thead-light pe-auto" style="background: #dee2e6" width="120"
                        [ngClass]="z==6||z==4||z==5 ||z==13||z==12 ||z==2||z==3||z==0||z==9?'width200':z==8?'width140':z==7?'width220':'width120'"> <!--:z==0?'width80'-->
                        {{headername}} <img src="/images/Separator.svg" alt="icon"class="float-right"
                          height="22px" ><!--[ngClass]="z==7 ||z==6||z==5||z==8||z==3?'ml-4':z==4||z==12?'ml-6':z==13||z==1?'ml-7':z==9||z==10||z==11?'ml-2_5':z==2?'ml-3':z==tableheaders.length-1?'d-none':''">-->
                        
                        </th>
                    </tr>
                    </thead>
                    <tr *ngIf="railDetailsData?.length === 0">
                    <td colspan="7" class="text-center fs-18 text-secondary bold">
                        No Results
                    </td>
                    </tr>
                    <ng-container>
                    <tbody >
                        <tr *ngFor="let railDetail of railDetailsData; track index; " class="small">
                        <td class="static fs-16 whitespace">{{railDetail?.rail}}</td>
                        <td class="static fs-16 whitespace">{{railDetail?.railCarId}}</td>
                        <td class="static fs-16 whitespace">{{railDetail?.material}}</td>
                        <td class="static fs-16 whitespace">{{railDetail?.scheduleQty}}</td>
                        <td class="fs-16 whitespace">{{railDetail?.actualQty}}</td>
                        <td class="fs-16 whitespace">{{railDetail?.contractID}}</td>
                        <td class="whitespace" >{{railDetail?.masterAgreementNum}}</td>
                        <td class="whitespace" >{{railDetail?.purchaseOrderNo}}</td>
                        <td class="whitespace" >{{railDetail?.batchID}}</td>
                        <td class="whitespace" >{{railDetail?.destination}}</td>
                        <td class="whitespace">{{railDetail?.formattedEtds}}</td>
                        <td class="whitespace" >{{railDetail?.formattedAtds}}</td>
                        <td class="whitespace" >{{railDetail?.formattedEtad}}</td>
                        <td class="whitespace pe-auto">
                          <span *ngIf="railDetail.documents && railDetail.documents.length > 0; else noDocuments">
                            <span *ngFor="let document of railDetail.documents; let last = last" class="text-primary ">
                              <div class="d-block" (click)="donwloadReport(document)" >{{document.documentName}}<span *ngIf="!last">, </span></div>
                            </span>
                          </span>
                          <ng-template #noDocuments>
                            <span class="text-muted">No documents</span>
                          </ng-template>
                        </td>
                        <td class=" whitespace" >{{railDetail?.remarks}}</td>
                        <td class=" whitespace" ><div class="badge  " [ngClass]="railDetail.status=='Sent For Scheduling'? 
                          'badge-secondary':railDetail.status=='Confirmed'?
                          'badge-success':railDetail.status=='Scheduled'?
                          'badge-scheduled':railDetail.status=='Departed'?
                          'badge-departed':railDetail.status=='Arrived at destination'?
                          'badge-purple':''">{{railDetail?.status}}</div></td>            
                        </tr>
                    </tbody>
                    </ng-container>

                </table>
                </form>
        </div>
          <div class="pagination-controls justify-content-end">
            <span class="mr-5">{{showingFrom}}-{{showingTo}} of {{totalItems}}</span>
            <span (click)="firstPage()" class="mr-4 pe-auto" [class.disabled]="hasPrevious=='false'"><img
              src="/images/first_page.svg" width="15px" height="15px"></span>
            <span (click)="previousPage()" class="mr-4 pe-auto" [class.disabled]="hasPrevious=='false'"><i
                class="fa fa-lg fa-chevron-left text-secondary"></i></span>
            <span (click)="nextPage()" class="mr-4 pe-auto" [class.disabled]="hasNext=='false'"><i
                class="fa fa-lg fa-chevron-right text-secondary"></i></span>
            <span (click)="lastPage()" class="mr-4 pe-auto" [class.disabled]="hasNext=='false'"><img
                src="/images/last_page.svg" width="15px" height="15px"></span>
          </div>
    </div>
  </div>
</div>